import {
  Button,
  Input,
  Card,
  Grid,
  Dropdown,
  Tooltip,
  Space,
  Skeleton,
  Modal,
  Slider,
  ConfigProvider,
  BackTop,
} from "antd";
import React, { useEffect, useState } from "react";
import { AppDispatch, RootState } from "../../../../../store/app";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchCareers,
  addRemoveJob,
  fetchCareerCategorys,
  fetchCareerCategoryDetails,
} from "../Utils/slice";
import { redirect, useNavigate, useParams } from "react-router-dom";
import { ArrowUpOutlined, SearchOutlined, UpCircleOutlined } from "@ant-design/icons";
import CustomRadio from "./CustomRadio";
import "../../../../../assets/styles/custom/customStyles/cutomStyles.css";
import FilterModal from "./FilterModal";
import SVGIcon from "../../../../../utils/SVGIcon";
import { formatGlobalPrice } from "../../../../../config/Global";
import InfiniteScroll from "react-infinite-scroll-component";
import BreadcrumbComponent from "../../../CommonComponent/BreadcrumbComponent";
import { EnergyCareersIndexBreadcrumb } from "../../../../../config/BreadcrumbConfig";
import ArrowDown from "../../../../../assets/images/arrow_down.svg";
import { CONSTANT } from "../../../../../config/Constant";

const { useBreakpoint } = Grid;


/**
 * Strips HTML tags from a string and returns only text content
 */
const stripHtml = (html: string) => {
  const tmp = document.createElement("div");
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || "";
};

/**
 * Renders component for All Careers .
 *
 * @return {JSX.Element} The rendered component.
 */
const Index = () => {
  // const { career_category } = useParams();
  // console.log(career_category);
  const screens = useBreakpoint();
  const [pageLoading, setPageLoading] = useState<boolean>(false);
  const translationLanguage = useSelector((state: RootState) => state.COMMON.translationLanguage);

  const [loading, setLoading] = useState<boolean>(false);
  const dispatch: AppDispatch = useDispatch();
  const careerList = useSelector(
    (state: RootState) => state.WEBPROFILE.careerList
  );
  const careerListPagination = useSelector(
    (state: RootState) => state.WEBPROFILE.pagination
  );
  const careerListCount = useSelector(
    (state: RootState) => state.WEBPROFILE.count
  );

  const navigate = useNavigate();
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [showName, setShowName] = useState<string>("");
  const [searchValue, setSearchValue] = useState("");
  const [inputValue, setInputValue] = useState("");

  const [CarierCategoryList, setCarierCategoryList] = useState<any>([]);
  const [mobileFilterVisible, setMobileFilterVisible] = useState(false);
  const [salaryModalVisible, setSalaryModalVisible] = useState(false); // Add modal state
  const [showFilterCount, setShowFilterCount] = useState(false);

  const sortOptions = [
    { label: "Name: A → Z", value: "ASC", data: "name" },
    { label: "Name: Z → A", value: "DESC", data: "name" },
    { label: "Salary: Low to High", value: "ASC1", data: "salary_avg" },
    { label: "Salary: High to Low", value: "DESC1", data: "salary_avg" },
  ];
  const [sortOrder, setSortOrder] = useState("ASC");
  const [selectedCategories, setSelectedCategories] = useState<string[]>([]);
  const [salaryRange, setSalaryRange] = useState<[string, string]>(["", ""]);
  const [salaryRangeInput, setSalaryRangeInput] = useState<[string, string]>(["", ""]);
  // Initialize page state from sessionStorage or default to 1
  const [page, setPage] = useState<number>(() => {
    const savedPage = sessionStorage.getItem("careerListPage");
    return savedPage ? parseInt(savedPage, 10) : 1;
  });
  const [categoryDropdownOpen, setCategoryDropdownOpen] = useState(false);
  const [sortDropdownOpen, setSortDropdownOpen] = useState(false);
  const [sortBy, setSortBy] = useState<string>("name");



  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);



  const handleClearAll = () => {
    setSortOrder("ASC");
    setSortBy('name');
    setSelectedCategories([]);
    setSalaryRange(["", ""]);
    setSalaryRangeInput(["", ""]);
    setSelectedCategory("all");
    setShowName("All Categories");
    setInputValue("");
    setSearchValue("");
    setShowFilterCount(false);
    // ReloadTable();
    setMobileFilterVisible(false);
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    setPageLoading(true);
    dispatch(fetchCareerCategorys())
      .then((data: any) => {
        setLoading(false);
        setPageLoading(false);
        setCarierCategoryList([
          { id: "all", full_name: "All Categories" },
          ...data.data,
        ]);
      })
      .catch((e: any) => {
        setCarierCategoryList([]);
        setLoading(false);
        setPageLoading(false);
      });
  }, []);

  // Cleanup function to clear sessionStorage when component unmounts
  useEffect(() => {
    return () => {
      sessionStorage.removeItem("careerListPage");
    };
  }, []);

  // useEffect(() => {
  //   console.log('career_category',career_category)
  // if (career_category != undefined) {
  //   if (career_category == "all") {
  //     setSelectedCategory(career_category);
  //     setPageLoading(false);
  //   } else {
  //     getCareerCategoryDetails(atob(career_category));
  //   }
  // } else {
  //   setSelectedCategory("craft");
  // }
  // setSearchValue("");
  // }, [career_category]);

  // const getCareerCategoryDetails = (career_category_id: any) => {
  //   dispatch(fetchCareerCategoryDetails(career_category_id))
  //     .then((response: any) => {
  //       setPageLoading(false);
  //       if (!response.data) {
  //         redirect("careers");
  //       }
  //       setSelectedCategory(response.data);
  //       // console.log('data',response.data.name);
  //     })
  //     .catch((e: any) => {
  //       setPageLoading(false);
  //       redirect("careers");
  //     });
  // };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setSearchValue(inputValue);
    }, 1000);
    return () => clearTimeout(timeoutId);
  }, [inputValue]);

  useEffect(() => {
    if (searchValue != "" || selectedCategory != null) {
      ReloadTable();
    }
  }, [searchValue, selectedCategory, sortOrder, salaryRange]);


  const ReloadTable = () => {
    setLoading(true);
    setPage(1); // Always reset to page 1 on new search/filter
    // Reset the page number in sessionStorage when filters are applied
    sessionStorage.setItem("careerListPage", "1");
    const categoryPass =
      selectedCategory && selectedCategory != "all" ? selectedCategory : null;
    dispatch({
      type: "WEBPROFILE/setCareerListData",
      payload: { rows: [], page: 1 },
    });
    dispatch(
      fetchCareers(
        searchValue,
        categoryPass,
        1,
        sortOrder == "ASC" || sortOrder == "ASC1" ? "ASC" : "DESC",
        salaryRange[0],
        salaryRange[1],
        sortBy
      )
    )
      .then(() => {
        setPage(2);
        // Store the new page number in sessionStorage
        sessionStorage.setItem("careerListPage", "2");
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const SaveAndRemoveFromJobListProcess = (career_id: any, status: number) => {
    const requestData = {
      career_id: career_id,
      add: status,
    };
    setLoading(true);
    dispatch(addRemoveJob(requestData))
      .then((data: any) => {
        setLoading(false);
        // Update the specific career item in the list without reloading
        const updatedCareerList = careerList.map((career: any) => {
          if (career.id === career_id) {
            return {
              ...career,
              is_saved: status === 1,
            };
          }
          return career;
        });
        // Dispatch action to update the Redux store with the modified list
        dispatch({
          type: "WEBPROFILE/setCareerListData",
          payload: {
            rows: updatedCareerList,
            page: careerListPagination?.page || 1,
          },
        });
      })
      .catch((e: any) => {
        setLoading(false);
        // Even in case of error, we don't want to reload the entire table
        console.error("Error saving/removing career:", e);
      });
  };

  const loadMoreData = async () => {
    await dispatch(
      fetchCareers(
        searchValue,
        selectedCategory,
        page,
        sortOrder == "ASC" || sortOrder == "ASC1" ? "ASC" : "DESC",
        salaryRange[0],
        salaryRange[1],
        sortBy
      )
    );
    const newPage = page + 1;
    setPage(newPage);
    // Store the new page number in sessionStorage
    sessionStorage.setItem("careerListPage", newPage.toString());
  };

  return (
    <>
      <section>
        <div className="container-fluid">
          <div className="career-index-header mobile-header">
            {screens.sm ? (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: 12,
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <BreadcrumbComponent
                  key={1}
                  items={EnergyCareersIndexBreadcrumb.path}
                />
                <Input
                  className="career-index-search notranslate"
                  placeholder={translationLanguage == "es" ? "La búsqueda solo funciona en inglés" : "Search"}
                  prefix={<SearchOutlined style={{ color: "#bdbdbd" }} />}
                  onChange={(e) => setInputValue(e.target.value)}
                  value={inputValue}
                  style={{ maxWidth: 480, borderRadius: 12 }}
                />
              </div>
            ) : (
              <>
                <div className="mobile-header-row">
                  <BreadcrumbComponent
                    key={1}
                    items={EnergyCareersIndexBreadcrumb.path}
                  />
                </div>
                <div className="mobile-search-filter-row">
                  <Input
                    className="career-index-search notranslate"
                    placeholder={translationLanguage == "es" ? "La búsqueda solo funciona en inglés" : "Search"}
                    style={{
                      borderRadius: 12,
                      borderColor: "#fff",
                    }}
                    prefix={<SearchOutlined style={{ color: "#bdbdbd" }} />}
                    onChange={(e) => setInputValue(e.target.value)}
                  />
                  <div className="filter-icon-wrapper">
                    <Button
                      className="filter-btn-mobile"
                      icon={<SVGIcon icon="filter" width={22} />}
                      onClick={() => setMobileFilterVisible(true)}
                      style={{ backgroundColor: "#fff", borderColor: "#fff" }}
                    />
                    {showFilterCount && (
                      <div onClick={() => setMobileFilterVisible(true)}>
                        <span className="filter-badge">{careerListCount}</span>
                      </div>
                    )}
                  </div>
                </div>
              </>
            )}
            {/* Desktop Filters/Sort */}
            <div className="career-index-filters desktop-filters">
              <div className="career-index-filters-row">
                <div
                  className="career-index-filter-label"
                  style={{ fontSize: 16 }}
                >
                  Filter by:
                </div>
                <ConfigProvider
                  theme={{
                    token: {
                      controlItemBgHover: "#DFFBDF", // Example: a light blue for hover
                    },
                  }}
                >
                  <Dropdown
                    menu={{
                      items: CarierCategoryList.map((item: any) => ({
                        ...item,
                        label: item.full_name,
                        value: item.id,
                        key: item.id,
                        onClick: () => {
                          // Update the category selection
                          setSelectedCategory(
                            item.id === "all" ? "all" : item.code
                          );
                          setShowName(item.full_name);
                          setCategoryDropdownOpen(false);

                          // Force API reload when category changes
                          // setTimeout(() => {
                          //   const categoryPass =
                          //     item.id === "all" ? null : item.code;
                          //   dispatch(
                          //     fetchCareers(
                          //       searchValue,
                          //       categoryPass,
                          //       1,
                          //       sortOrder === "ASC" || sortOrder === "ASC1"
                          //         ? "ASC"
                          //         : "DESC",
                          //       salaryRange[0],
                          //       salaryRange[1],
                          //       sortBy
                          //     )
                          //   );
                          // }, 0);
                        },
                      })),
                    }}
                    trigger={["click"]}
                    placement="bottomLeft"
                    open={categoryDropdownOpen}
                    onOpenChange={setCategoryDropdownOpen}
                  >
                    <Space
                      style={{
                        height: 48,
                        border: `1px solid ${categoryDropdownOpen ? "#169C16" : "#e0e0e0"
                          }`,
                        borderRadius: 12,
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                      className="custom-sort-btn"
                    >
                      {showName === ""
                        ? "All Categories"
                        : showName.length > 13
                          ? `${showName.slice(0, 13)}...`
                          : showName}

                      <img
                        src={ArrowDown}
                        alt="arrow"
                        style={{
                          width: 20,
                          height: 20,
                          marginLeft: 8,
                          transition: "transform 0.2s",
                          transform: categoryDropdownOpen
                            ? "rotate(180deg)"
                            : "rotate(0deg)",
                          display: "inline-block",
                          verticalAlign: "middle",
                          marginTop: -2,
                        }}
                      />
                    </Space>
                  </Dropdown>
                </ConfigProvider>
                {/* Replace Salary Dropdown with a clickable div */}
                <div
                  className="custom-sort-btn"
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    cursor: "pointer",
                    userSelect: "none",
                    height: 48,
                    border: `1px solid ${salaryModalVisible ? "#169C16" : "#e0e0e0"
                      }`,
                    borderRadius: 12,
                  }}
                  onClick={() => setSalaryModalVisible(true)}
                >
                  {salaryRange[0] && salaryRange[1]
                    ?
                    <>
                      Salary
                      <div className="notranslate">
                        : {formatGlobalPrice(salaryRange[0])} - {formatGlobalPrice(salaryRange[1])}
                      </div>
                    </>
                    : <>Salary</>}
                  <img
                    src={ArrowDown}
                    alt="arrow"
                    style={{
                      width: 20,
                      height: 20,
                      marginLeft: 8,
                      transition: "transform 0.2s",
                      transform: salaryModalVisible
                        ? "rotate(180deg)"
                        : "rotate(0deg)",
                      display: "inline-block",
                      verticalAlign: "middle",
                      marginTop: -2,
                    }}
                  />
                </div>

                <div
                  className="custom-sort-btn"
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    cursor: "pointer",
                    userSelect: "none",
                    justifyContent: "center",
                    borderColor: "red",
                    color: "red",
                    height: 48,
                    borderRadius: 12,
                  }}
                  onClick={() => handleClearAll()}
                >
                  Reset filter
                </div>
              </div>
              <div className="career-index-filters-row">
                <div
                  className="career-index-sort-label"
                  style={{ fontSize: 16 }}
                >
                  Sort by:
                </div>
                <ConfigProvider
                  theme={{
                    token: {
                      controlItemBgHover: "#DFFBDF",
                    },
                  }}
                >
                  <Dropdown
                    open={sortDropdownOpen}
                    onOpenChange={setSortDropdownOpen}
                    trigger={["click"]}
                    placement="bottomRight"
                    dropdownRender={() => (
                      <div
                        className="custom-sort-dropdown"
                        style={{
                          padding: 12,
                          background: "#fff",
                          borderRadius: 12,
                          minWidth: 200,
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 10,
                          }}
                        >
                          {sortOptions.map((option) => (
                            <CustomRadio
                              key={option.value}
                              value={option.value}
                              label={option.label}
                              checked={sortOrder === option.value}
                              onChange={() => {
                                setSortOrder(option.value);
                                const selected = sortOptions.find(
                                  (opt) => opt.value === option.value
                                );
                                setSortBy(selected ? selected.data : "name");

                                // Delay closing dropdown slightly
                                setTimeout(() => {
                                  setSortDropdownOpen(false);
                                }, 150); // 100–200ms gives enough time to show selection
                              }}
                            />
                          ))}
                        </div>
                      </div>
                    )}
                  >
                    <Space
                      style={{
                        height: 48,
                        border: `1px solid ${sortDropdownOpen ? "#169C16" : "#e0e0e0"
                          }`,
                        borderRadius: 12,
                        padding: "0 12px",
                        cursor: "pointer",
                      }}
                      className="custom-sort-btn"
                    >
                      {sortOptions.find((o) => o.value === sortOrder)?.label ||
                        sortOptions[0].label}
                      <img
                        src={ArrowDown}
                        alt="arrow"
                        style={{
                          width: 20,
                          height: 20,
                          marginLeft: 8,
                          transition: "transform 0.2s",
                          transform: sortDropdownOpen
                            ? "rotate(180deg)"
                            : "rotate(0deg)",
                          display: "inline-block",
                          verticalAlign: "middle",
                          marginTop: -2,
                        }}
                      />
                    </Space>
                  </Dropdown>
                </ConfigProvider>
              </div>
            </div>
          </div>
          {/* Mobile Filter Modal */}
          <FilterModal
            open={mobileFilterVisible}
            onClose={() => {
              setMobileFilterVisible(false);
              // Optionally reload data here if needed
            }}
            sortOptions={sortOptions}
            sortOrder={sortOrder}
            sortBy={sortBy}
            setSortOrder={setSortOrder}
            setSortBy={setSortBy}
            categoryList={CarierCategoryList}
            selectedCategories={selectedCategories}
            setSelectedCategories={setSelectedCategories}
            setSelectedCategory={setSelectedCategory} // Add this
            setShowName={setShowName} // Add this
            salaryRange={salaryRange}
            setSalaryRange={setSalaryRange}
            handleClearAll={handleClearAll}
            setShowFilterCount={setShowFilterCount}
          />
          {/* Header Section End */}
          <div className="career-list">
            <InfiniteScroll
              dataLength={careerList.length}
              next={loadMoreData}
              hasMore={careerList.length < careerListPagination?.total}
              loader={
                loading ? (
                  <Skeleton avatar paragraph={{ rows: 1 }} active />
                ) : null
              }
              scrollableTarget="scrollableDiv"
            >
              {careerList && careerList.length > 0 ? (
                careerList.map((item: any) => (
                  <Card
                    className="career-card-row"
                    key={item.id}
                    variant={'borderless'}
                    styles={{ body: { padding: "24px" } }}
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      // console.log("item", item.id);
                      navigate(`/careers/details/${item.id}`);
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        // alignItems: "center
                      }}
                    >
                      <div style={{ flex: 1 }}>
                        <div
                          style={{
                            fontSize: 22,
                            fontWeight: 700,
                            marginBottom: 8,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <h2
                            className="career-card-title"
                            style={{
                              whiteSpace: "wrap",
                              fontSize: 24,
                              color: "#000",
                              fontWeight: 600,
                            }}
                          >
                            {item.name}
                          </h2>
                          {!screens.md && (
                            <div
                              style={{ placeSelf: "start" }}
                              onClick={(e) => e.stopPropagation()}
                              className="examTooltip-mobile"
                            >
                              <Tooltip
                                placement="top"
                                title={
                                  item.is_saved
                                    ? "Remove from Saved List"
                                    : "Add to Saved List"
                                }
                              >
                                <Button
                                  className="common_button rounded green-btn save-button"
                                  disabled={loading ? true : false}
                                  icon={
                                    item.is_saved ? (
                                      <SVGIcon
                                        icon="SavedFilled"
                                        width={30}
                                        color={"#169C16"}
                                      />
                                    ) : (
                                      <SVGIcon
                                        icon="Save"
                                        width={30}
                                        color={"#169C16"}
                                      />
                                    )
                                  }
                                  onClick={() => {
                                    if (loading) return;
                                    setLoading(true);
                                    SaveAndRemoveFromJobListProcess(
                                      item.id,
                                      item.is_saved ? 0 : 1
                                    );
                                  }}
                                />
                              </Tooltip>
                            </div>
                          )}
                        </div>
                        <span
                          style={{
                            color: "#0981AA",
                            fontSize: 16,
                            display: "inline-block",
                          }}
                        >
                          {item.categories && item.categories.length > 0
                            ? item.categories
                              .map((cat: any) => cat.category?.name)
                              .filter(Boolean)
                              .join(", ")
                            : "-"}
                        </span>

                        <div
                          style={{
                            color: "#555",
                            fontSize: 15,
                            marginTop: 8,
                            maxWidth: "95%",
                          }}
                        >
                          {(() => {
                            const desc = item.description
                              ? stripHtml(item.description)
                              : "";
                            if (
                              typeof window !== "undefined" &&
                              window.innerWidth <= 767
                            ) {
                              return desc.length > 100
                                ? desc.slice(0, 100) + "..."
                                : desc;
                            } else {
                              return desc.length > 200
                                ? desc.slice(0, 200) + "..."
                                : desc;
                            }
                          })()}
                        </div>
                        <div
                          className="card-price"
                          style={{
                            fontSize: 18,
                            fontWeight: 700,
                            marginTop: "4%",
                            color: "#222",
                          }}
                        >
                          {formatGlobalPrice(item.salary_start)} -{" "}
                          {formatGlobalPrice(item.salary_end)}
                        </div>
                      </div>

                      <div
                        className="tooltip-button"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignSelf: "center",
                          justifyContent: "flex-end",
                          alignItems: "flex-end",
                          minWidth: 180,
                          gap: 12,
                          borderWidth: 1,
                        }}
                        onClick={(e) => e.stopPropagation()}
                      >
                        <div className="examTooltip">
                          <Tooltip
                            placement="top"
                            title={
                              item.is_saved
                                ? "Remove from Saved List"
                                : "Add to Saved List"
                            }
                          >
                            <Button
                              className={
                                "common_button rounded green-btn save-button"
                              }
                              disabled={loading ? true : false}
                              icon={
                                !item?.is_saved ? (
                                  <SVGIcon
                                    icon="Save"
                                    width={30}
                                    color={"#169C16"}
                                  />
                                ) : (
                                  <SVGIcon
                                    icon="SavedFilled"
                                    width={30}
                                    color={"#169C16"}
                                  />
                                )
                              }
                              onClick={() => {
                                if (loading) return;
                                setLoading(true);
                                SaveAndRemoveFromJobListProcess(
                                  item.id,
                                  item.is_saved ? 0 : 1
                                );
                              }}
                            />
                          </Tooltip>
                        </div>
                        <div
                          style={{
                            fontSize: 18,
                            fontWeight: 700,
                            color: "#222",
                            alignItems: "flex-end",
                            justifyContent: "flex-end",
                            display: "flex",
                            marginRight:
                              item.salary_start == null &&
                                item.salary_end == null
                                ? 10
                                : 0,
                          }}
                        >
                          {formatGlobalPrice(item.salary_start)} -{" "}
                          {formatGlobalPrice(item.salary_end)}
                        </div>
                      </div>
                    </div>
                  </Card>
                ))
              ) : loading ? (
                <Skeleton avatar paragraph={{ rows: 1 }} active />
              ) : (
                <div>No careers found.</div>
              )}
            </InfiniteScroll>
          </div>
        </div>
      </section>

      <Modal
        title="Select Salary Range"
        open={salaryModalVisible}
        centered
        onCancel={() => setSalaryModalVisible(false)}
        maskClosable={true}
        closeIcon={false}
        onOk={undefined}
        footer={
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              gap: 10,
            }}
          >
            <Button
              style={{
                borderColor: "#169C16",
                color: "#169C16",
                background: "transparent",
                boxShadow: "none",
                transition: "none",
              }}
              onClick={() => setSalaryModalVisible(false)}
            >
              Cancel
            </Button>
            <Button
              type="primary"
              onClick={() => {


                let val1: any = salaryRangeInput[0];
                let val2 = salaryRangeInput[1];
                let output: [string, string];
                if (val1 != '' && val2 != '') {
                  val1 = Number(val1);
                  if (Math.abs(val1) > Number(val2)) {
                    output = [val2, Math.abs(val1).toString()];
                  }
                  else {
                    output = [Math.abs(val1).toString(), val2];
                  }
                }
                else {
                  output = [val1, val2]
                }
                setSalaryRangeInput(output);
                setSalaryRange(output);



                setTimeout(() => {
                  setSalaryModalVisible(false);
                }, 300)


              }}
            >
              OK
            </Button>
          </div>
        }
      >
        <div style={{ margin: "24px 0" }}>
          <ConfigProvider
            theme={{
              components: {
                Slider: {
                  handleColor: "#0B400C",
                  handleLineWidth: 3,
                  handleLineWidthHover: 3,
                  handleActiveColor: "#0B400C",
                  handleActiveOutlineColor: "rgba(11, 64, 12, 0.2)",
                  trackBg: "#0B400C",
                  railBg: "#E2E8F0",
                  controlSize: 20, // Optional: height of slider
                },
              },
            }}
          >
            <Slider
              range
              min={parseFloat(CONSTANT.MIN_SALARY)}
              max={parseFloat(CONSTANT.MAX_SALARY)}
              step={1000}
              value={salaryRangeInput.map(Number)}
              onChange={(value) =>
                setSalaryRangeInput(
                  (value as number[]).map(String) as [string, string]
                )
              }
              className="custom-slider"
              tooltip={{ formatter: (v) => <div className="notranslate">{`$${v}`}</div> }}
              dots={false}
              styles={{
                handle: {
                  color: "#0B400C",
                  borderColor: "#0B400C",
                  backgroundColor: "#0B400C",
                },
                track: {
                  backgroundColor: "#0B400C",
                },
                rail: {
                  backgroundColor: "#E2E8F0",
                },
              }}
            />
          </ConfigProvider>
          <div
            style={{
              width: "100%",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              display: "flex",
              marginTop: 20,
            }}
          >
            <Input
              style={{ width: "45%", height: 50 }}
              type="number"
              min={parseFloat(CONSTANT.MIN_SALARY)}
              max={salaryRangeInput[1]}
              value={salaryRangeInput[0]}
              onChange={(e: any) => {
                const val1 = e.target.value;
                if (parseFloat(val1) > parseFloat(CONSTANT.MAX_SALARY)) {
                  setSalaryRangeInput([CONSTANT.MAX_SALARY, salaryRangeInput[1]])
                  return;
                }
                if (parseFloat(val1) < parseFloat(CONSTANT.MIN_SALARY)) {
                  setSalaryRangeInput([CONSTANT.MIN_SALARY, salaryRangeInput[1]])
                  return;
                }
                const val2 = salaryRangeInput[1];

                setSalaryRangeInput([val1, val2])

              }}
            />
            <span className="salary-separator">-</span>
            <Input
              style={{ width: "45%", height: 50 }}
              type="number"
              min={salaryRangeInput[0]}
              max={parseFloat(CONSTANT.MAX_SALARY)}
              value={salaryRangeInput[1]}
              onChange={(e: any) => {

                const val1 = e.target.value;
                if (parseFloat(val1) > parseFloat(CONSTANT.MAX_SALARY)) {
                  setSalaryRangeInput([salaryRangeInput[0], CONSTANT.MAX_SALARY])
                  return;
                }
                if (parseFloat(val1) < parseFloat(CONSTANT.MIN_SALARY)) {
                  setSalaryRangeInput([salaryRangeInput[0], CONSTANT.MIN_SALARY])
                  return;
                }
                const val2 = salaryRangeInput[0];

                setSalaryRangeInput([val2, val1])

              }}
            />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: 6,
            }}
          >
            <span>Min: <div className="notranslate">{formatGlobalPrice(salaryRangeInput[0])}</div></span>
            <span>Max: <div className="notranslate">{formatGlobalPrice(salaryRangeInput[1])}</div></span>
          </div>
        </div>
      </Modal>
      {screens.xl == false &&
        scrollY > 1 &&
        <BackTop
          visibilityHeight={1000}
          children={<Button type="primary" icon={<ArrowUpOutlined />} />}
        />}
    </>
  );
};

export default Index;
